<template>
  <div class="data-view-wrapper clearfix" v-if="service && isLoad">
    <div class="data-view">
      <div class="data-view__title">{{ $t("integration.service_title") }}</div>
      <div class="data-view__data">
        {{ service.attributes.service }}
      </div>
    </div>

    <div class="data-view">
      <div class="data-view__title">
        {{ $t("integration.service_integrated") }}
      </div>
      <div class="data-view__data">
        {{ getDateFormat(service.attributes.created_at) }}
      </div>
    </div>

    <div v-if="salesForceApiData.custom_formatter" class="data-view">
      <div class="data-view__title">
        {{ $t("integration.service_custom_formatter", "Custom formatter") }}
      </div>
      <div class="data-view__data">
        {{ salesForceApiData.custom_formatter }}
      </div>
    </div>

    <div v-if="salesForceApiData.chabad_one_campaign_id" class="data-view">
      <div class="data-view__title">
        {{ $t("integration.service_chabad_one_campaign_id", "Chabad One Campaign ID") }}
      </div>
      <div class="data-view__data">
        {{ salesForceApiData.chabad_one_campaign_id }}
      </div>
    </div>

    <div class="data-view">
      <div class="data-view__title">
        {{
          $t("integration.service_autoexport_for_campaigns", "Limit Export for Campaign ID list")
        }}
      </div>
      <div class="data-view__data">
        <b-form-tags
          placeholder="Campaign ID List"
          input-type="number"
          v-model="salesForceApiData.autoexport_for_campaigns"
        ></b-form-tags>
      </div>
    </div>

    <div v-if="isChabadOne" class="data-view">
      <div class="data-view__title">
        {{ $t("integration.sales_force_include_recurring_charges", "Include Recurring Charges") }}
      </div>
      <div class="data-view__data">
        <b-form-checkbox v-model="salesForceApiData.include_recurring_charges" switch />
      </div>
    </div>

    <div class="data-view">
      <div class="data-view__title">
        {{ $t("integration.service_limit_by_gateway", "Limit Export for Gateway") }}
      </div>
      <div class="data-view__data">
        <Multiselect
          v-model="salesForceApiData.limit_by_gateway"
          :options="paymentSystemOptions"
          multiple
          taggable
        />
      </div>
    </div>

    <div class="data-view">
      <div class="data-view__title">
        {{ $t("integration.service_exclude_gateways", "Exclude Gateway") }}
      </div>
      <div class="data-view__data">
        <Multiselect
          v-model="salesForceApiData.exclude_gateways"
          :options="paymentSystemOptions"
          multiple
          taggable
        />
      </div>
    </div>

    <div v-if="!isChabadOne" class="wrapper-options">
      <button
        type="button"
        @click="showOptionaly = !showOptionaly"
        class="show-hide-bttn"
        name="button"
      >
        {{
          !showOptionaly
            ? $t("integration.map_donors_property_show")
            : $t("integration.map_donors_property_hide")
        }}
        <i :class="!showOptionaly ? 'fa fa-angle-down' : 'fa fa-angle-up'" aria-hidden="true"></i>
      </button>
    </div>

    <div class="optionally-params" v-if="showOptionaly">
      <div class="data-view multi-row">
        <div class="data-view-row row">
          <div class="col-12 col-md-5">
            <div class="data-view__title">
              {{ $t("integration.donor_Object_type") }}
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div class="data-view__data input">
              <b-form-select
                id="field-select-type"
                v-model="objectTypeDonor"
                :options="objectTypeList"
              ></b-form-select>
            </div>
          </div>
        </div>

        <div class="data-view-row row">
          <div class="col-12 col-md-5">
            <div class="data-view__title" v-if="objectTypeDonor === 'Custom'">
              {{ $t("integration.donor_custom_type") }}
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div class="data-view__data" v-if="objectTypeDonor === 'Custom'">
              <b-form-input v-model="objectTypeDonorValue"> </b-form-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row import-manual__row" v-for="(item, index) in donorFields" :key="index">
        <div class="col-12 col-md-5">
          <div class="form-group">
            <p>
              {{
                item.charidy_field && item.charidy_field != "static"
                  ? $t("integration.charidy-field")
                  : $t("integration.static_value")
              }}
            </p>

            <b-form-select
              v-if="item.new"
              id="field-select"
              :class="item.new && item.charidy_field === 'static' ? 'margin-static-select' : ''"
              v-model="item.charidy_field"
              :options="donorFieldsName"
            ></b-form-select>

            <b-form-input
              v-if="item.charidy_field && !item.new"
              disabled
              v-model="item.charidy_field"
            >
            </b-form-input>
            <b-form-input
              v-if="
                (item.static_value && item.charidy_field != 'static') ||
                (item.new && item.charidy_field === 'static')
              "
              :disabled="!item.new"
              v-model="item.static_value"
            >
            </b-form-input>
            <p class="charidy-field-desc" v-if="fieldDescription(item.charidy_field)">
              {{ fieldDescription(item.charidy_field) }}
            </p>
          </div>
        </div>

        <div class="col-12 col-md-5">
          <div class="form-group">
            <p :class="item.new && item.charidy_field === 'static' ? 'margin-static-field' : ''">
              {{ $t("integration.salesforse-field") }}
            </p>
            <b-form-input v-model="item.salesforce_field"></b-form-input>
          </div>
        </div>
        <div class="col-12 col-md-2 btn-box">
          <a class="import-manual__delete" role="button" @click.prevent="deleteDonorFields(index)">
            {{ $t("dashboard.add_donate_delete_row") }}
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 btn-row">
          <span class="import-manual__action">
            <button class="import-manual__add-row" @click.prevent="addDonorRow">
              {{ $t("dashboard.add_donate_add_row") }}
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="wrapper-options">
      <button
        type="button"
        @click="showOptionalyDonation = !showOptionalyDonation"
        class="show-hide-bttn"
        name="button"
      >
        {{
          !showOptionalyDonation
            ? $t("integration.map_donation_property_show")
            : $t("integration.map_donation_property_hide")
        }}
        <i
          :class="!showOptionalyDonation ? 'fa fa-angle-down' : 'fa fa-angle-up'"
          aria-hidden="true"
        ></i>
      </button>
    </div>
    <div class="optionally-params" v-if="showOptionalyDonation">
      <div class="data-view multi-row">
        <div class="data-view-row row">
          <div class="col-12 col-md-5">
            <div class="data-view__title">
              {{ $t("integration.donation_Object_type", "Object type") }}
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div class="data-view__data">
              <b-form-select
                id="field-select-type"
                v-model="objectTypeDonation"
                :options="objectTypeList"
              ></b-form-select>
            </div>
          </div>
        </div>

        <div class="data-view-row row">
          <div class="col-12 col-md-5">
            <div class="data-view__title" v-if="objectTypeDonation === 'Custom'">
              {{ $t("integration.donation_custom_type", "Custom type") }}
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div class="data-view__data" v-if="objectTypeDonation === 'Custom'">
              <b-form-input v-model="objectTypeDonationValue"> </b-form-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row import-manual__row" v-for="(item, index) in donationFields" :key="index">
        <div class="col-12 col-md-5">
          <div class="form-group">
            <p>
              {{
                item.charidy_field && item.charidy_field != "static"
                  ? $t("integration.charidy-field")
                  : $t("integration.static_value")
              }}
            </p>

            <b-form-select
              v-if="item.new"
              id="field-select"
              :class="item.new && item.charidy_field === 'static' ? 'margin-static-select' : ''"
              v-model="item.charidy_field"
              :options="donationFieldsName"
            ></b-form-select>

            <b-form-input
              v-if="item.charidy_field && !item.new"
              disabled
              v-model="item.charidy_field"
            >
            </b-form-input>
            <b-form-input
              v-if="
                (item.static_value && item.charidy_field != 'static') ||
                (item.new && item.charidy_field === 'static')
              "
              :disabled="!item.new"
              v-model="item.static_value"
            >
            </b-form-input>
            <p class="charidy-field-desc" v-if="fieldDescription(item.charidy_field)">
              {{ fieldDescription(item.charidy_field) }}
            </p>
          </div>
        </div>

        <div class="col-12 col-md-5">
          <div class="form-group">
            <p :class="item.new && item.charidy_field === 'static' ? 'margin-static-field' : ''">
              {{ $t("integration.salesforse-field") }}
            </p>
            <b-form-input v-model="item.salesforce_field"></b-form-input>
          </div>
        </div>

        <div class="col-12 col-md-2 btn-box">
          <a
            class="import-manual__delete"
            role="button"
            @click.prevent="deleteDonationFields(index)"
          >
            {{ $t("dashboard.add_donate_delete_row") }}
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 btn-row">
          <span class="import-manual__action">
            <button class="import-manual__add-row" @click.prevent="addDonationRow">
              {{ $t("dashboard.add_donate_add_row") }}
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="bttn bttn--lg bttn--blue" @click.prevent="updateStep">
        {{ $t("gateways.close_view") }}
      </button>
      <button
        class="bttn bttn--lg bttn--orange el-right"
        @click.prevent="updateSalesForceIntegrationDataMap"
      >
        {{ $t("gateways.update_view") }}
      </button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import urls from "@/constants/urls.js";
import moment from "moment";
import { usePaymentSystemListApi } from "@/composables/payment-system-list";
import Multiselect from "vue-multiselect";

// Full catalog of Charidy data points that the Salesforce integration can map,
// mirroring the backend resolver (model/org_account_integrations/salesforce/
// fieldMap/fieldsMapper.go). This is hardcoded so the "Charidy field" dropdown
// shows every available field — not only the ones already present in the saved
// map. `charged_with_tip` and `charidy_tip` are intentionally excluded.
const DONATION_CHARIDY_FIELDS = [
  {
    value: "created_at",
    text: "Donation date",
    description: "Date the donation was made (YYYY-MM-DD).",
  },
  {
    value: "charidy_donation_id",
    text: "Charidy donation ID",
    description: "Unique Charidy donation identifier.",
  },
  {
    value: "invoice_no",
    text: "Invoice number",
    description: "Charidy invoice number for the donation.",
  },
  {
    value: "gateway_transaction_id",
    text: "Gateway transaction ID",
    description: "Transaction ID from the payment gateway.",
  },
  {
    value: "gateway",
    text: "Gateway / bank name",
    description: "Name of the payment gateway or bank used.",
  },
  {
    value: "payment_firstname",
    text: "Billing first name",
    description: "First name from the billing details.",
  },
  {
    value: "payment_lastname",
    text: "Billing last name",
    description: "Last name from the billing details (N/A if empty).",
  },
  {
    value: "display_name",
    text: "Display name",
    description: "Donor's display / account holder name.",
  },
  {
    value: "campaign_charidy_id",
    text: "Campaign ID",
    description: "Charidy campaign ID the donation belongs to.",
  },
  { value: "campaign_name", text: "Campaign name", description: "Title of the campaign." },
  {
    value: "donation_amount",
    text: "Donation amount",
    description: "The donor's real payment amount (text).",
  },
  {
    value: "donation_amount_float",
    text: "Donation amount (number)",
    description: "Charged amount as a number, including tip.",
  },
  {
    value: "donation_total",
    text: "Donation total",
    description: "Total donation value including matching (text).",
  },
  {
    value: "donation_total_float",
    text: "Donation total (number)",
    description: "Total donation value as a number.",
  },
  {
    value: "real_payment",
    text: "Real payment",
    description: "Amount actually paid, formatted to 2 decimals.",
  },
  {
    value: "donation_currency",
    text: "Currency",
    description: "Currency code of the donation (e.g. USD).",
  },
  {
    value: "donation_last4",
    text: "Card last 4",
    description: "Last 4 digits of the payment card.",
  },
  { value: "dedication", text: "Dedication", description: "Donor's comment / dedication message." },
  {
    value: "donation_stream",
    text: "Donation stream",
    description: "Revenue/donation stream the donation is attributed to.",
  },
  { value: "phone", text: "Phone", description: "Donor phone number." },
  { value: "email", text: "Email", description: "Donor email address." },
  {
    value: "team_id",
    text: "Team ID",
    description: "ID of the team the donation is attributed to.",
  },
  {
    value: "team_name",
    text: "Team name",
    description: "Name of the team the donation is attributed to.",
  },
  {
    value: "referrer_id",
    text: "Referrer ID",
    description: "Referrer identifier captured with the donation.",
  },
  {
    value: "offline_donation_source",
    text: "Offline source",
    description: "Source of an offline donation.",
  },
  {
    value: "offline_donation_note",
    text: "Offline note",
    description: "Note recorded for an offline donation.",
  },
  {
    value: "salesforce_donor_id",
    text: "Salesforce Contact ID",
    description: "Linked Salesforce donor (Contact) record ID.",
  },
  {
    value: "salesforce_donor_account_id",
    text: "Salesforce Account ID",
    description: "Linked Salesforce donor Account record ID.",
  },
  {
    value: "address_street",
    text: "Address line 1",
    description: "Billing street address line 1.",
  },
  {
    value: "address_street2",
    text: "Address line 2",
    description: "Billing street address line 2.",
  },
  {
    value: "address_street_both_lines",
    text: "Address (both lines)",
    description: "Billing address lines 1 and 2 combined.",
  },
  { value: "address_city", text: "City", description: "Billing city." },
  { value: "address_state", text: "State / region", description: "Billing state or region." },
  { value: "address_zip", text: "Postal code", description: "Billing postal / ZIP code." },
  {
    value: "address_country_code",
    text: "Country code",
    description: "Billing country ISO-2 code (from GeoIP or billing country).",
  },
  { value: "address_country", text: "Country", description: "Billing country name." },
];

// The donor (Contact) resolver supports a subset of the donation fields.
const DONOR_CHARIDY_FIELD_VALUES = new Set([
  "created_at",
  "charidy_donation_id",
  "invoice_no",
  "gateway_transaction_id",
  "gateway",
  "payment_firstname",
  "payment_lastname",
  "display_name",
  "campaign_charidy_id",
  "campaign_name",
  "donation_amount",
  "donation_currency",
  "dedication",
  "phone",
  "email",
  "address_street",
  "address_street2",
  "address_street_both_lines",
  "address_city",
  "address_state",
  "address_zip",
  "address_country_code",
  "address_country",
]);

const CHARIDY_FIELD_CATALOG = {
  donationFields: DONATION_CHARIDY_FIELDS,
  donorFields: DONATION_CHARIDY_FIELDS.filter((f) => DONOR_CHARIDY_FIELD_VALUES.has(f.value)),
};

const CHARIDY_FIELD_DESCRIPTIONS = DONATION_CHARIDY_FIELDS.reduce((acc, f) => {
  acc[f.value] = f.description;
  return acc;
}, {});

export default {
  props: ["service"],

  data() {
    return {
      salesForceApiData: {},
      showOptionaly: false,
      showOptionalyDonation: false,
      donorApiData: null,
      isLoad: null,
      donorFields: [],
      donationFields: [],
      objectTypeList: ["Account", "Contact", "Lead", "Custom"],
      objectTypeDonor: null,
      objectTypeDonation: null,
      objectTypeDonorValue: null,
      objectTypeDonationValue: null,
      donorFieldsName: [],
      donationFieldsName: [],
      errors: [],
      /**
       * @type {Array<string>}
       */
      paymentSystemOptions: [],
    };
  },

  components: {
    Multiselect,
  },

  computed: {
    isChabadOne() {
      return this.salesForceApiData.custom_formatter === "ChabadOne";
    },
  },

  methods: {
    fieldList(section) {
      // Full list of available Charidy fields for this section, plus the
      // "Static field" option. Previously this was derived only from fields
      // already present in the saved map, so users could not discover or add
      // fields that weren't already mapped.
      const options = (CHARIDY_FIELD_CATALOG[section] || []).map((field) => ({
        value: field.value,
        text: field.text,
      }));

      options.push({ value: "static", text: "Static field" });

      return options;
    },

    fieldDescription(value) {
      if (!value || value === "static") return "";
      return CHARIDY_FIELD_DESCRIPTIONS[value] || "";
    },

    addRow(fieldsArray) {
      const fieldObj = {
        new: true,
        charidy_field: "static",
        salesforce_field: "",
        static_value: "",
      };
      fieldsArray.push(fieldObj);
    },

    deleteFields(index, fieldsArray) {
      if (index !== -1) {
        fieldsArray.splice(index, 1);
      }
    },

    addDonorRow() {
      this.addRow(this.donorFields);
    },

    addDonationRow() {
      this.addRow(this.donationFields);
    },

    deleteDonorFields(id) {
      this.deleteFields(id, this.donorFields);
    },

    deleteDonationFields(id) {
      this.deleteFields(id, this.donationFields);
    },

    getSalesForceIntegrationDataMap() {
      const orgId = localStorage.getItem("orgId");
      const url = urls.getSalesforceIntegrationDataMapV2(orgId, this.service.id);

      axios.get(url).then(this.handleSalesforceIntegrationDataMapResponse);
    },

    getSalesForceIntegrationDefaultDataMap() {
      const orgId = localStorage.getItem("orgId");
      const url = urls.getSalesforceIntegrationDefaultDataMapV2(orgId);

      axios.get(url).then(this.handleSalesforceIntegrationDataMapResponse);
    },

    handleSalesforceIntegrationDataMapResponse(response) {
      this.salesForceApiData = response.data;
      this.isLoad = true;
      this.getDonorDataMap();
      this.getDonationDataMap();
    },

    updateSalesForceIntegrationDataMap() {
      const orgId = localStorage.getItem("orgId");

      const processFields = (fields) => {
        fields.forEach((item) => {
          if (item.new) {
            delete item.new;
          }
          if (item.charidy_field === "static") {
            item.charidy_field = "";
          }
        });

        return fields;
      };

      this.salesForceApiData.donor_data_mapping = processFields(this.donorFields);
      this.salesForceApiData.donation_data_mapping = processFields(this.donationFields);

      const donorSObjectType =
        this.objectTypeDonor !== "Custom" ? this.objectTypeDonor : this.objectTypeDonorValue;
      const donationSObjectType =
        this.objectTypeDonation !== "Custom"
          ? this.objectTypeDonation
          : this.objectTypeDonationValue;

      this.salesForceApiData.donor_sobject_type = donorSObjectType;
      this.salesForceApiData.donation_sobject_type = donationSObjectType;

      const url = urls.getSalesforceIntegrationDataMapV2(orgId, this.service.id);

      this.salesForceApiData.autoexport_for_campaigns =
        this.salesForceApiData.autoexport_for_campaigns.map((e) => Number(e));

      axios.post(url, this.salesForceApiData).then(this.handleSalesforceIntegrationDataMapUpdate);
    },

    handleSalesforceIntegrationDataMapUpdate() {
      this.$emit("update-step");
    },

    getDonorDataMap() {
      const donorSObjectType = this.salesForceApiData.donor_sobject_type;

      this.donorFields = (this.salesForceApiData.donor_data_mapping || []).filter((item) => {
        return (
          (item.charidy_field && item.salesforce_field) ||
          (item.static_value && item.salesforce_field) ||
          item.new ||
          this.isChabadOne
        );
      });

      this.donorFieldsName = this.fieldList("donorFields");

      this.objectTypeDonor = this.checkType(donorSObjectType);
      if (this.objectTypeDonor === "Custom") {
        this.objectTypeDonorValue = donorSObjectType;
      }
    },

    checkType(type) {
      return type !== "Account" && type !== "Contact" && type !== "Lead" ? "Custom" : type;
    },

    getDonationDataMap() {
      const donationSObjectType = this.salesForceApiData.donation_sobject_type;

      this.donationFields = (this.salesForceApiData.donation_data_mapping || []).filter((item) => {
        return (
          (item.charidy_field && item.salesforce_field) ||
          (item.static_value && item.salesforce_field) ||
          item.new ||
          this.isChabadOne
        );
      });

      this.donationFieldsName = this.fieldList("donationFields");

      this.objectTypeDonation = this.checkType(donationSObjectType);
      if (this.objectTypeDonation === "Custom") {
        this.objectTypeDonationValue = donationSObjectType;
      }
    },

    updateStep() {
      this.$emit("update-step");
    },

    getDateFormat(date) {
      return moment.unix(date).format("MMMM D, YYYY h:mm a");
    },

    clearDataModal() {
      this.gatewayInfo = null;
      this.errors = [];
    },
  },

  created() {
    const orgId = localStorage.getItem("orgId");

    const { getPaymentSystemList } = usePaymentSystemListApi(orgId);

    getPaymentSystemList().then((response) => {
      this.paymentSystemOptions = response.data.map((ps) => ps.system_name);
    });

    this.getSalesForceIntegrationDataMap();
  },
};
</script>

<style lang="scss" scoped>
.el-right {
  margin-left: auto;
}
.card {
  width: 100%;
}
.select {
  width: 50%;
}
.card-body {
  display: flex;
  align-items: center;
}
.type-input {
  height: 50px;
  width: 100%;
  margin: 0;
}

.donation-show-hide-options {
  border: 0;
  background: transparent;
  width: 100%;
  text-align: center;
  outline: none;
  margin: 30px 0;
}
.margin-static-field {
  margin-bottom: 80px;
}
.margin-static-select {
  margin-bottom: 15px;
}

.form-group {
  input {
    width: 100%;
  }
}
.charidy-field-desc {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #6b7280;
}

.import-manual {
  &__row {
    &:hover {
      .import-manual__delete {
        opacity: 1;
      }
    }
  }
  &__add-row {
    cursor: pointer;
    margin: 0;
    padding: 0 13px;
    height: 26px;
    font-size: 12px;
    line-height: 26px;
    text-transform: uppercase;
    background-color: #f2f4f5;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 13px;
    &:hover,
    &:focus,
    &:active {
      background-color: #f2f4f5;
      outline: 0;
      box-shadow: none;
    }
  }
  &__delete {
    opacity: 0;
    font-size: 14px;
    font-family: "ProximaNova-Regular", sans-serif;
    color: #cc6d4c;
    text-transform: capitalize;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    &:hover,
    &:focus {
      color: darken(#cc6d4c, 5%);
      text-decoration: none;
    }
  }
}
.footer {
  display: flex;
}
.optionally-params {
  margin-bottom: 15px;
}
.custom-select {
  height: 50px;
  border-radius: 4px;
}
.btn-box {
  align-items: center;
  display: flex;
  .import-manual__delete {
    margin-top: 20px;
    color: #cc6d4c;
  }
}

.btn-row {
  text-align: center;
  padding: 15px 0;
}
.wrapper-options {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 2px;
    background-color: #999999;
    position: absolute;
    top: calc(50% - 1px);
    left: 0;
    z-index: 0;
  }
  button {
    width: auto;
    position: relative;
    &:focus {
      outline: 0;
    }
  }
}

.multi-row {
  flex-wrap: wrap;
  .data-view__title {
    min-width: 50%;
    max-width: 50%;
  }
  input {
    width: 100%;
  }
}

.data-view-row {
  width: 100%;
  display: flex;
  align-items: center;
}
.data-view__data {
  max-width: 100%;
  width: 100%;
  margin-left: 15px;
}
</style>
